import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// imporing icons this way because I cannot make tree-shaking working.
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus'
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt'
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag'
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey'
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle'
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench'
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks'
import { faPercent } from '@fortawesome/free-solid-svg-icons/faPercent'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faIdBadge } from '@fortawesome/free-solid-svg-icons/faIdBadge'
import { faUtensils } from '@fortawesome/free-solid-svg-icons/faUtensils'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt'
import { faHourglass } from '@fortawesome/free-solid-svg-icons/faHourglass'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe'
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload'
import { faVoteYea } from '@fortawesome/free-solid-svg-icons/faVoteYea'
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion'
import { faTable } from '@fortawesome/free-solid-svg-icons/faTable'
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera'
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen'
import { faMicrophone } from '@fortawesome/free-solid-svg-icons/faMicrophone'
import { faBus } from '@fortawesome/free-solid-svg-icons/faBus'
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck'
import { faBed } from '@fortawesome/free-solid-svg-icons/faBed'
import { faHotel } from '@fortawesome/free-solid-svg-icons/faHotel'
import { faDoorClosed } from '@fortawesome/free-solid-svg-icons/faDoorClosed'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap'
import { faUniversity } from '@fortawesome/free-solid-svg-icons/faUniversity'
import { faCommentAlt } from '@fortawesome/free-solid-svg-icons/faCommentAlt'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import { faCoins } from '@fortawesome/free-solid-svg-icons/faCoins'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory'
import { faUmbrellaBeach } from '@fortawesome/free-solid-svg-icons/faUmbrellaBeach'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faStop } from '@fortawesome/free-solid-svg-icons/faStop'
import { faBookReader } from '@fortawesome/free-solid-svg-icons/faBookReader'
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome'
import { faHandHoldingMedical } from '@fortawesome/free-solid-svg-icons/faHandHoldingMedical'
import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage'
import { faGlobeEurope } from '@fortawesome/free-solid-svg-icons/faGlobeEurope'
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList'

library.add(faTimesCircle)
library.add(faHeart)
library.add(faBars)
library.add(faUser)
library.add(faAngleDown)
library.add(faEye)
library.add(faSignInAlt)
library.add(faUserPlus)
library.add(faTachometerAlt)
library.add(faCalendar)
library.add(faFlag)
library.add(faKey)
library.add(faCircle)
library.add(faWrench)
library.add(faTasks)
library.add(faPercent)
library.add(faExternalLinkAlt)
library.add(faCheck)
library.add(faIdBadge)
library.add(faUtensils)
library.add(faShoppingCart)
library.add(faSpinner)
library.add(faMinus)
library.add(faPencilAlt)
library.add(faHourglass)
library.add(faCheckCircle)
library.add(faPhone)
library.add(faEnvelope)
library.add(faClock)
library.add(faSignOutAlt)
library.add(faTimes)
library.add(faPlus)
library.add(faDollarSign)
library.add(faEdit)
library.add(faAngleUp)
library.add(faGlobe)
library.add(faSave)
library.add(faUpload)
library.add(faVoteYea)
library.add(faQuestion)
library.add(faTable)
library.add(faUsers)
library.add(faCamera)
library.add(faPen)
library.add(faMicrophone)
library.add(faBus)
library.add(faTruck)
library.add(faBed)
library.add(faHotel)
library.add(faDoorClosed)
library.add(faGraduationCap)
library.add(faUniversity)
library.add(faCommentAlt)
library.add(faInfoCircle)
library.add(faTrashAlt)
library.add(faCoins)
library.add(faExclamationCircle)
library.add(faHistory)
library.add(faUmbrellaBeach)
library.add(faPlay)
library.add(faStop)
library.add(faBookReader)
library.add(faHome)
library.add(faHandHoldingMedical)
library.add(faLanguage)
library.add(faGlobeEurope)
library.add(faClipboardList)

export default FontAwesomeIcon
